import React from 'react';
import { Plus } from 'lucide-react';

export default function KPIHeader({ onAdd }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Manajemen KPI</h1>
        <p className="text-gray-500 mt-1">Kelola Key Performance Indicators</p>
      </div>
      <button
        onClick={onAdd}
        className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md font-medium flex items-center justify-center"
      >
        <Plus className="w-4 h-4 mr-2" /> Tambah KPI
      </button>
    </div>
  );
}
